"use strict";

exports.__esModule = true;
exports.useScrollRestoration = exports.ScrollContext = void 0;

var _scrollHandler = require("./scroll-handler");

exports.ScrollContext = _scrollHandler.ScrollHandler;

var _useScrollRestoration = require("./use-scroll-restoration");

exports.useScrollRestoration = _useScrollRestoration.useScrollRestoration;